import React, { useRef, useState } from "react";
import Wrapper from "../Components/Wrapper";
import AboutImg from "../assets/images/AboutImg.webp";
import icon1 from "../assets/images/icons/quality.png";
import icon2 from "../assets/images/icons/solutions.png";
import comparison from "../assets/images/comparison.webp";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { data } from "../assets/API/data";
import ProgressBar from "@ramonak/react-progress-bar";

function Home() {
  const [Ndata] = useState([data]);
  const navigation_btn = useNavigate();
  const allSemesterRef = useRef(null);

  return (
    <Wrapper>
      <section className="homePage">
        <div className="heroSection d-flex  justify-content-center align-items-center">
          <Col lg={8} data-aos="fade-up">
            <h1 className="heroHeadingTwo fw-bold lh-md">
              Your <span>Ultimate</span> <br /> Hub for <span>BCA</span> <br />
              Success
            </h1>

            <button
              onClick={() => {
                allSemesterRef.current.scrollIntoView({ behavior: "smooth" });
              }}
              className="nav-Button py-md-2 px-md-4 py-lg-3 px-lg-5 py-2 px-4 mt-lg-5 mt-sm-4"
            >
              Browse More
            </button>
          </Col>
        </div>

        <div className="moreAboutUsSection py-5">
          <Container>
            <Row>
              <Col lg={6} data-aos="fade-right">
                <div className="me-lg-4">
                  <img className="about-img" src={AboutImg} alt="" />
                </div>
              </Col>
              <Col lg={6} data-aos="fade-left">
                <p className="subHeading fw-bolder fs-5">More About Us</p>
                <h3 className="heading fw-bold mt-2 mb-4">
                  We Provide Exceptional Solutions for Clients
                </h3>
                <p>
                  A wonderful serenity has taken possession of my entire soul,
                  like these sweet mornings of spring.
                </p>
                <div className="my-4 d-flex align-items-start gap-4">
                  <div className="icon-div">
                    <img className="img-fluid" src={icon1} alt="" />
                  </div>
                  <div>
                    <h3 className="features-heading">
                      <Link to="/your-link-path">Quality Content</Link>
                    </h3>
                    <p>
                      Expert-curated notes ensure accuracy and relevance for
                      comprehensive BCA learning.
                    </p>
                  </div>
                </div>
                <div className="my-4 d-flex align-items-start gap-4">
                  <div className="icon-div">
                    <img className="img-fluid" src={icon2} alt="" />
                  </div>
                  <div>
                    <h3 className="features-heading">
                      <Link to="/your-link-path">
                        Language that is easy to use
                      </Link>
                    </h3>
                    <p>
                      Simplified jargon and user-friendly design for effortless
                      BCA understanding.
                    </p>
                  </div>
                </div>
                <div className="my-4 d-flex align-items-start gap-4">
                  <div className="icon-div">
                    <img className="img-fluid" src={icon1} alt="" />
                  </div>
                  <div>
                    <h3 className="features-heading">
                      <Link to="/your-link-path">Quality Content</Link>
                    </h3>
                    <p>
                      Expert-curated notes ensure accuracy and relevance for
                      comprehensive BCA learning.
                    </p>
                  </div>
                </div>

                <div className="btn-wrapper">
                  <button
                    onClick={() => {
                      navigation_btn("/about");
                    }}
                    className="nav-Button py-3 px-5 mt-2"
                  >
                    Browse More
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div ref={allSemesterRef} className="allSemWrapper text-center">
          <Container>
            <p className="subHeading fw-bold pt-5 mb-2">More Service</p>
            <h2 className="heading fw-bold text-light mt-3">All Semester</h2>
            <div className="allCards">
              <Row>
                {Ndata[0].map((item) => {
                  return (
                    <Col xl={4} md={6} key={item.id} className="gy-4">
                      <Card
                        className="text-center px-5 py-4"
                        data-aos={
                          item?.id <= 4 ? "zoom-out-down" : "zoom-out-up"
                        }
                        data-aos-delay={item?.id * 200}
                        data-aos-duration="600"
                      >
                        <Card.Img
                          className="mb-2"
                          variant="top"
                          src={item.img}
                          alt=""
                        />
                        <Card.Body>
                          <Card.Title className="text-white mb-3">
                            <h3 className="fw-semibold">
                              {item.heading} Semester
                            </h3>
                          </Card.Title>
                          <Card.Text className="text-white mb-3">
                            {item.overview}
                          </Card.Text>
                          <Link to={`/semisters/${item.slug}`}>
                            <button className="nav-Button py-2 px-4 mt-2">
                              Browse More
                            </button>
                          </Link>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </Container>
        </div>

        <div className="comparison">
          <Container>
            <Row className="gy-5">
              <Col lg={6} className="comparison-column" data-aos="fade-right">
                <p className="subHeading fw-bold">Our Benefits</p>
                <h2 className="heading my-3 fw-semibold">
                  More Than Just Academic Success
                </h2>
                <p className="my-4 compOverview">
                  Experience a holistic learning journey designed to empower BCA
                  students with practical skills, community support, and career
                  readiness.
                </p>
                <div className="progessDiv d-flex flex-column row-gap-4">
                  <div>
                    <p className="mb-2 progressTitle">
                      Comprehensive Resources
                    </p>
                    <ProgressBar
                      bgColor=" linear-gradient(-45deg, #F33F5E, #FF7E00)"
                      completed={99}
                      height="8px"
                      isLabelVisible={false}
                      transitionDuration="1s"
                      animateOnRender
                      maxCompleted={100}
                    />
                  </div>

                  <div>
                    <p className="mb-2 progressTitle">Interactive Learning</p>
                    <ProgressBar
                      bgColor=" linear-gradient(-45deg, #F33F5E, #FF7E00)"
                      completed={90}
                      height="8px"
                      isLabelVisible={false}
                      transitionDuration="1s"
                      animateOnRender
                      maxCompleted={100}
                    />
                  </div>

                  <div>
                    <p className="mb-2 progressTitle">Career Guidance</p>
                    <ProgressBar
                      bgColor=" linear-gradient(-45deg, #F33F5E, #FF7E00)"
                      completed={80}
                      height="8px"
                      isLabelVisible={false}
                      transitionDuration="1s"
                      animateOnRender
                      maxCompleted={100}
                    />
                  </div>
                </div>
                <div className="buttonDiv">
                  <button
                    onClick={() => {
                      navigation_btn("/about");
                    }}
                    className="nav-Button py-md-3 px-md-5  mt-sm-5 mt-4"
                  >
                    Browse More
                  </button>
                </div>
              </Col>

              <Col lg={6} data-aos="fade-left">
                <div className="overflow-hidden ratio-1x1 ratio">
                  <img
                    className="img-fluid rounded-4"
                    src={comparison}
                    alt=""
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </Wrapper>
  );
}

export default Home;
